'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _alert = require('./alert/alert.module');

var _alert2 = _interopRequireDefault(_alert);

var _appMenu = require('./app-menu/app-menu.module');

var _appMenu2 = _interopRequireDefault(_appMenu);

var _appToolbar = require('./app-toolbar/app-toolbar.module');

var _appToolbar2 = _interopRequireDefault(_appToolbar);

var _attest = require('./attest/attest.module');

var _attest2 = _interopRequireDefault(_attest);

var _categoryAutocomplete = require('./autocomplete/category/category-autocomplete.module');

var _categoryAutocomplete2 = _interopRequireDefault(_categoryAutocomplete);

var _changePassword = require('./change-password/change-password.module');

var _changePassword2 = _interopRequireDefault(_changePassword);

var _companyAutocomplete = require('./autocomplete/company/company-autocomplete.module');

var _companyAutocomplete2 = _interopRequireDefault(_companyAutocomplete);

var _dialogClose = require('./dialog-close/dialog-close.module');

var _dialogClose2 = _interopRequireDefault(_dialogClose);

var _ingredientAutocomplete = require('./autocomplete/ingredient/ingredient-autocomplete.module');

var _ingredientAutocomplete2 = _interopRequireDefault(_ingredientAutocomplete);

var _itemList = require('./item-list/item-list.module');

var _itemList2 = _interopRequireDefault(_itemList);

var _feedback = require('./feedback/feedback.module');

var _feedback2 = _interopRequireDefault(_feedback);

var _productLabelUpload = require('./product-label-upload/product-label-upload.module');

var _productLabelUpload2 = _interopRequireDefault(_productLabelUpload);

var _regulatorAutocomplete = require('./autocomplete/regulator/regulator-autocomplete.module');

var _regulatorAutocomplete2 = _interopRequireDefault(_regulatorAutocomplete);

var _userAddForm = require('./user-add-form/user-add-form.module');

var _userAddForm2 = _interopRequireDefault(_userAddForm);

var _userEditForm = require('./user-edit-form/user-edit-form.module');

var _userEditForm2 = _interopRequireDefault(_userEditForm);

var _userList = require('./user-list/user-list.module');

var _userList2 = _interopRequireDefault(_userList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.common', [_alert2.default, _appMenu2.default, _appToolbar2.default, _attest2.default, _categoryAutocomplete2.default, _changePassword2.default, _companyAutocomplete2.default, _dialogClose2.default, _feedback2.default, _ingredientAutocomplete2.default, _itemList2.default, _productLabelUpload2.default, _regulatorAutocomplete2.default, _userAddForm2.default, _userEditForm2.default, _userList2.default]).name;


// WEBPACK FOOTER //
// ./components/app/common/common.module.js